import { useTranslation } from 'react-i18next';
import { NUMERATION_SCHEMA_ENDPOINT } from '../../../../consts';
import { useHasPermission } from '../../../../contexts/auth';
import { useListCount } from '../../../../hooks/useListCount';
import { TENANT_ROUTES } from '../../tenantConfig.routes';
import { SETTINGS_SECTIONS } from '../../tenantSettings.config';
import { TenantSection } from './tenantSection.component';

/** The workspace-wide configuration, one page per area it affects. */
export const TenantSettingsSectionLayout = () => {
  const { t } = useTranslation();
  const canViewSettings = useHasPermission('config.view_tenantsettings');
  const canViewSchemas = useHasPermission('settlement.view_numerationschema');
  const schemasCount = useListCount(NUMERATION_SCHEMA_ENDPOINT, canViewSchemas);

  return (
    <TenantSection
      tabs={[
        ...(canViewSettings
          ? [{ key: 'general', label: t(SETTINGS_SECTIONS.general.title), path: TENANT_ROUTES.settings }]
          : []),
        ...(canViewSettings || canViewSchemas
          ? [
              {
                key: 'numbering',
                label: t(SETTINGS_SECTIONS.numbering.title),
                path: TENANT_ROUTES.numbering,
                count: schemasCount,
              },
            ]
          : []),
        ...(canViewSettings
          ? [
              { key: 'invoicing', label: t(SETTINGS_SECTIONS.invoicing.title), path: TENANT_ROUTES.invoicing },
              {
                key: 'reminders',
                label: t(SETTINGS_SECTIONS.reminders.title),
                path: TENANT_ROUTES.reminders,
              },
              { key: 'client-portal', label: t('Client portal'), path: TENANT_ROUTES.clientPortal },
              { key: 'integrations', label: t('Integrations'), path: TENANT_ROUTES.integrations },
            ]
          : []),
      ]}
    />
  );
};
